module.exports = __webpack_public_path__ + "static/media/linkedin-icon.c9ef0186.svg";